import { toIndianCurrencyHeader } from "../../../MethodMaster/JSXComponentMothod";
import "../DashboardUnique.css";

export default function YojnaDetailHeader({ yojna, handleNavigateToMainTab }) {
  return (
    <div className={"govdash-yojnaDetailHeader"}>
      <div onClick={handleNavigateToMainTab} className={"govdash-detailIconWrapper cursor-pointer"}>
        <i className={`${yojna.IconName} ${"govdash-detailIcon"}`}></i>
      </div>
      <div className={"govdash-detailInfo"}>
        <h2 className={"govdash-detailName"}>{yojna.GramYojnaName}</h2>
        <div className={"govdash-detailStats"}>
          <div className={"govdash-statItem"}>
            <span className={"govdash-statLabel"}>Labharthi</span>
            <span className={"govdash-statValue"}>{yojna.BeneficialCount?.toLocaleString()}</span>
          </div>
          {!!Number(yojna?.TotalAmount || 0) && (
            <div className={"govdash-statItem"}>
              <span className={"govdash-statLabel"}>Amount</span>
              {/* <span className={'govdash-statValue'}>₹{yojna.TotalAmount?.toLocaleString()}</span> */}
              <span className={"govdash-statValue"}>
                ₹{yojna.TotalAmount?.toLocaleString()}
                {toIndianCurrencyHeader(parseFloat(yojna.TotalAmount))}
              </span>
            </div>
          )}
          <div className={"govdash-statItem"}>
            <span className={"govdash-statLabel"}>Status</span>
            <span className={`${"govdash-statusBadge"} ${true ? "govdash-active" : "govdash-inactive"}`}>{true ? "Active" : "Inactive"}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
